import React from "react";
import ReactDOM from "react-dom";
// Templates
import Note from "./templates/Note";

export default function Handouts() {
    const mainText = `
    STRAIL受講生サイト内でダウンロードできる解説プリントをまとめています。
  `;
    const textList = [
        {
            text:
                "●「主な音声変化まとめ」プリント （Dictation & Overlapping動画用）",
            fileName: "主な音声変化ルール_まとめプリント_STRAIL"
        },
        {
            text: "●「品詞判別」レジュメ （品詞判別トレーニング動画用）",
            fileName: "品詞判別レジュメ_STRAIL"
        },
        {
            text: "●「単語の覚え方」プリント （キクタンアプリの使い方 動画用）",
            fileName: "単語の覚え方プリント_STRAIL"
        },
        {
            text: "●「単語の覚え方」プリント 初級編（ユメタンの使い方 動画用）",
            fileName: "単語の覚え方_初級編"
        },
        {
            text: "●「前置詞」プリント",
            fileName: "前置詞プリント_STRAIL"
        },
        {
            text: "●「ディスコースマーカー・リスト」プリント",
            fileName: "ディスコースマーカー・リスト"
        }
    ];

    return <Note mainText={mainText} textList={textList} />;
}

if (document.getElementById("handouts")) {
    ReactDOM.render(<Handouts />, document.getElementById("handouts"));
}
